import React, {useContext, useState, useEffect} from 'react';
import './TickersEmergenza.css';
import axios from 'axios';
import config from '../../../config';
import { AuthContext } from '../../../contexts/authContext';
import { EditIcon, TrashIcon, AddIcon, CachedIcon } from '../../../assets/icons/icons';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import {
    DataGridPremium
} from '@mui/x-data-grid-premium';
import ManageTickersEmergenzaDialog from './ManageTickersEmergenzaDialog';
import DeleteTickersEmergenzaDialog from './DeleteTickersEmergenzaDialog';
import { getFormatDate } from '../../../utils/CommonUtilities';
import { LicenseInfo } from '@mui/x-license';
import useNotification from '../../../hooks/useNotification';

LicenseInfo.setLicenseKey(config.MUI_DATA_GRID_PREMIUM_LICENSE);

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, getTickersEmergenza) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {getTickersEmergenza()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' title='Inserisci Fermata' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

function TickersEmergenza(props) {
    const auth = useContext(AuthContext);
    const { tickersEmergenza, setTickersEmergenza } = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [tickersEmergenzaLoading, setTickersEmergenzaLoading] = useState(true);

    const [openManageTickersEmergenzaDialog, setOpenManageTickersEmergenzaDialog] = useState(false);
    const [openDeleteTickersEmergenzaDialog, setOpenDeleteTickersEmergenzaDialog] = useState(false);
    const [lastCellData, setLastCellData] = useState(null);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 100, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, disableExport: true, renderHeader: (params) => ActionHeaderCell(params, handleOpenManageTickersEmergenzaDialog, getTickersEmergenza), renderCell: (params) => ActionCell(params, handleOpenManageTickersEmergenzaDialog, handleOpenDeleteTickersEmergenzaDialog)},
        /* {field: 'idEntita', headerClassName: 'header-cell id', headerName: 'Numero Fermata', type: 'string', width: 150, align: 'right', headerAlign: 'right', valueGetter: (params) => params?.S}, */
        {field: 'titolo', headerClassName: 'header-cell titolo', headerName: 'Titolo', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'itdescription', headerClassName: 'header-cell descrizione', headerName: 'Descrizione', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => params?.S},
        {field: 'expireDate', headerClassName: 'header-cell expireDate', headerName: 'Data di scadenza', type: 'string', flex: 1, align: 'left', headerAlign: 'left', valueGetter: (params) => getFormatDate(params?.S)},
    ]

    useEffect(() => {
        if(!tickersEmergenza.length){
            getTickersEmergenza();
        }else{
            setTickersEmergenzaLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getTickersEmergenza();
        }
    }, [props.city])

    const getTickersEmergenza = async() => {
        try {
            setLoading(true);
            setTickersEmergenzaLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-tickers-emergenza',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            setTickersEmergenza(response.data.dataToReturn);
            //setRows(response.data.dataToReturn);
            setTickersEmergenzaLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error?.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setTickersEmergenzaLoading(false);
            setLoading(false);
        }
    }

    const handleOpenManageTickersEmergenzaDialog = (action) => {
        setOpenManageTickersEmergenzaDialog(action)
    }
    const handleCloseManageTickersEmergenzaDialog = () => {
        setOpenManageTickersEmergenzaDialog(false);
    }

    const handleOpenDeleteTickersEmergenzaDialog = () => {
        setOpenDeleteTickersEmergenzaDialog(true);
    }   
    const handleCloseDeleteTickersEmergenzaDialog = () => {
        setOpenDeleteTickersEmergenzaDialog(false);
    }

    return (
        <div className='component-container tickers-emergenza'>
            <div className='component-card'>
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={tickersEmergenza}
                        columns={columns}
                        className="tickers-emergenza-table"
                        loading={tickersEmergenzaLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => row.idEntita.S}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                        //slots={{
                        //    toolbar: ()=>CustomToolbar(),
                        //}}
                    />
                </ThemeProvider>
            </div>
            <ManageTickersEmergenzaDialog {...{
                openManageTickersEmergenzaDialog,
                handleCloseManageTickersEmergenzaDialog,
                lastCellData,
                getTickersEmergenza,
                city: props.city
            }}/>
            <DeleteTickersEmergenzaDialog {...{
                openDeleteTickersEmergenzaDialog,
                handleCloseDeleteTickersEmergenzaDialog,
                lastCellData,
                getTickersEmergenza
            }}/>
        </div>
    )
}

export default TickersEmergenza